import {
  Carousel
} from '@vodacom/web-common';

export const Templates = {
  'single page': 'SinglePage',
  'list pillar page': 'ListPillars'
};

export const ComponentList = {
  'carousel': {
    'component': Carousel
  }
};

export const ComponentLocation = {
  'above content': 'top',
  'below content': 'bottom'
};

export const ComponentSource = {
  'pillars': 'pillars'
};

export const CarouselParams = {
  componentList: '<!data!>'
};
